BaseModel = require './base_model.coffee'

class global.Carousel extends BaseModel
  @ATTRIBUTES = {
    id: {}
    next_user_id: {}
    kind: {}
    custom_field_id: {}
    custom_field_value: {}
    type: {}
  }

  @ASSOCIATIONS = {
    last_user: -> User
    next_user: -> User
    company: -> Company
    carousel_users: -> CarouselUser
  }

  @SERIALIZABLE_ATTRIBUTES = ['id', 'next_user_id', 'kind', 'custom_field_id', 'custom_field_value', 'type']

  @SERIALIZABLE_ASSOCIATIONS = ['carousel_users']



// WEBPACK FOOTER //
// ./src/models/carousel.coffee